// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  "aws_project_region": "eu-west-1",
  "Auth": {
    "userPoolId": "eu-west-1_odFenNFzS",
    "userPoolWebClientId": "4c98vpqst5e6rn4s4gh90g5usl"
  }
};


export default awsmobile;

